module.exports = __webpack_public_path__ + "img/PG4-2-515x387.8faf5199.png";